// export const getMoreList = (start = 0, res, list = []) =>
//   start === 0 ? (res?.data?.response ?? []) : [...list, ...(res?.data?.response ?? [])];

// export default getMoreList;

// =============

export const getMoreList = (start = 0, res, list = [], key) => {
  const response = key ? (res?.data?.response?.[key] ?? []) : (res?.data?.response ?? []);

  return start === 0 ? response : [...list, ...response];
};

export default getMoreList;
